import React from 'react';
import {useNavigate} from "react-router-dom";
import {toFaNumberFormat} from "@/lib/utils/number";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminDiscountUsages} from "@/api/discount";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

function DiscountUsageSection({id, discountData}) {

    const navigate = useNavigate();

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'کاربر',
            dataIndex: '-',
            key: '-',
            render: (text, record) => {
                return (<>
                    {record?.useracademy?.firstname} <b className={'mx-1'}>{record?.useracademy?.lastname}</b>
                </>)
            }
        },

        {
            title: 'مبلغ پایه',
            dataIndex: 'price',
            key: 'price',
            render: (text, record) => {
                return toFaNumberFormat(text);
            }
        },

        {
            title: 'مبلغ تخفیف',
            dataIndex: 'discount',
            key: 'discount',
            render: (text, record) => {
                return toFaNumberFormat(text);
            }
        },

        {
            title: 'درصد تخفیف اعمال شده',
            dataIndex: 'discount_percent',
            key: 'discount_percent',
            render: (text, record) => {
                return toFaNumberFormat(text) + '%';
            }
        },

        {
            title: 'مبلغ نهایی',
            dataIndex: 'final_price',
            key: 'final_price',
            render: (text, record) => {
                return toFaNumberFormat(text) + ' تومان ';
            }
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => {

                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
            }
        },


        //
        // {
        //     title: ' ',
        //     dataIndex: 'id',
        //     key: 'id',
        //     render: (text, record) => {
        //         return (<Link to={sprintf(URLS.admin.discount.edit, {id: record.id})}>
        //             <Button size={'small'} variant={'filled'}
        //                     color={'primary'}>ویرایش</Button>
        //         </Link>)
        //     }
        // },
    ];
    return (

        <Can permission={PermList.DISCOUNT_VIEW}>

            <TableSearch
                // searchInput={true}
                fnArgs={{id: id}}
                apiFn={useApiSearchAdminDiscountUsages}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </Can>


    );
}

export default DiscountUsageSection;